import { borderRadius, borderStyle } from "../styles";

export const graphStyle = {
  backgroundColor: "gray.50",
  padding: "4",
  borderBottomRadius: borderRadius,
  border: borderStyle,
};
